"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddSuscripcion = void 0;
var React = require("react");
var reactstrap_1 = require("reactstrap");
require("assets/css/p.css");
var url_js_1 = require("../variables/url.js");
var espolAds_1 = require("../variables/espolAds");
/*const localBack = 'http://localhost:3368/';*/
var localBack = url_js_1.default.localBack;
var categorias = localBack + 'api/Catalog/Categorias/preferencias';
var unidad = localBack + 'api/Catalog/Unidad';
var preferencias = localBack + 'api/Catalog/preferencias/';
var AddSuscripcion = /** @class */ (function (_super) {
    __extends(AddSuscripcion, _super);
    function AddSuscripcion(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { title: "", loading: true, status: 0, editando: true, mostrar: true, categoriaList: [], unidadList: [], categoriaCheck: [], unidadCheck: [] };
        /*console.log('alola');*/
        fetch(categorias)
            .then(function (response) { return response.json(); })
            .then(function (data) {
            _this.setState({ categoriaList: data });
        });
        fetch(unidad)
            .then(function (response) { return response.json(); })
            .then(function (data) {
            _this.setState({ unidadList: data });
        });
        fetch(preferencias, {
            method: 'GET',
            headers: { "Authorization": "Bearer " + espolAds_1.getCookie('token') },
        })
            .then(function (response) {
            _this.setState({ status: response.status });
            return response.json();
        })
            .then(function (data) {
            _this.setState({ title: "Edit", loading: false, editando: true, unidadCheck: data["unidad"], categoriaCheck: data["categoria"] });
            //console.log(data)
            //console.log("Unidad",this.state.unidadCheck);
            //console.log("Categoria",this.state.categoriaCheck);
        });
        var dtoid = _this.props.match.params["id"];
        // This will set state for Edit 
        if (dtoid > 0) {
            //fetch('http://localhost:3368/api/Catalog/Anuncios/' + dtoid, {
            //    method: 'GET',
            //    headers: { "Authorization": `Bearer ${sessionStorage.getItem('token')}` },
            //})
            //    .then(response => {
            //        this.setState({ status: response.status });
            //        return response.json() as Promise<AnunciosData>
            //    })
            //    .then(data => {
            //        this.setState({ title: "Edit", loading: false, editando: true, dtoData: data, fileName: data['txImagen'] });
            //        //Set mostrar en funcion de dto
            //    });
        }
        else {
            _this.state = { title: "Create", loading: false, editando: false, mostrar: true, categoriaList: [], unidadList: [], categoriaCheck: [], unidadCheck: [], status: 0 };
        }
        // This binding is necessary to make "this" work in the callback  
        _this.handleSave = _this.handleSave.bind(_this);
        _this.handleCancel = _this.handleCancel.bind(_this);
        //this.handleInputChange = this.handleInputChange.bind(this);
        _this.handleCheckChange = _this.handleCheckChange.bind(_this);
        _this.handleCheckChangeCat = _this.handleCheckChangeCat.bind(_this);
        return _this;
        //this.handleImageChange = this.handleImageChange.bind(this);
        //this.imageHandler = this.imageHandler.bind(this);
    }
    //handleInputChange(event) {
    //    const target = event.target;
    //    const value = target.type === 'checkbox' ? target.checked : target.value;
    //    const name = target.name;       
    //    var dto = this.state.dtoData;
    //    var tempDate = new Date();
    //    var year = tempDate.getFullYear()
    //    var mes = (tempDate.getMonth() + 1);
    //    var day = tempDate.getDate();
    //    if (mes >= 10) {
    //        var date = year + '-' + mes + '-' + day;
    //    } else {
    //        var date = year + '-' +'0'+ mes + '-' + day;
    //    }
    //    dto[name] = value;
    //    if (value) {
    //        dto["dtPublicacion"] = date;
    //        document.getElementById("dtPublicacion").setAttribute("readonly", "readonly");
    //    } else {
    //        dto["dtPublicacion"] = "";
    //        document.getElementById("dtPublicacion").innerHTML = "";
    //        document.getElementById("dtPublicacion").removeAttribute("readonly");
    //    }
    //    this.setState({ dtoData: dto });
    //    console.log(this.state.dtoData);
    //}
    AddSuscripcion.prototype.handleCheckChange = function (evnt) {
        var target = evnt.target;
        var value = target.type === 'checkbox' ? target.checked : target.value;
        var name = target.name;
        var cd = this.state.unidadCheck;
        if (value) {
            if (!cd.includes(name)) {
                cd.push(name);
            }
        }
        else {
            var n = cd.indexOf(name);
            if (n != -1) {
                cd.splice(n, 1);
            }
        }
        this.setState({ unidadCheck: cd });
        /*console.log(this.state.unidadCheck);*/
        var details = JSON.stringify({ "Unidad": this.state.unidadCheck, "Categoria": this.state.categoriaCheck });
        /*console.log(details);*/
    };
    AddSuscripcion.prototype.handleCheck = function (id, check) {
        var cd = this.state.unidadCheck;
        if (check) {
            var n = cd.indexOf(id);
            if (n != -1) {
                cd.splice(n, 1);
            }
        }
        else {
            if (!cd.includes(id)) {
                cd.push(id);
            }
        }
        this.setState({ unidadCheck: cd });
        /*console.log(this.state.unidadCheck);*/
        var details = JSON.stringify({ "Unidad": this.state.unidadCheck, "Categoria": this.state.categoriaCheck });
        /*console.log(details);*/
    };
    AddSuscripcion.prototype.handleCheckChangeCat = function (evnt) {
        var target = evnt.target;
        var value = target.type === 'checkbox' ? target.checked : target.value;
        var name = target.name;
        var cd = this.state.categoriaCheck;
        if (value) {
            if (!cd.includes(name)) {
                cd.push(name);
            }
        }
        else {
            var n = cd.indexOf(name);
            if (n != -1) {
                cd.splice(n, 1);
            }
        }
        this.setState({ categoriaCheck: cd });
        /*console.log(this.state.categoriaCheck);*/
        var details = JSON.stringify({ "Unidad": this.state.unidadCheck, "Categoria": this.state.categoriaCheck });
        /*console.log(details);*/
    };
    AddSuscripcion.prototype.handleCheckCat = function (id, check) {
        var cd = this.state.categoriaCheck;
        if (check) {
            var n = cd.indexOf(id);
            if (n != -1) {
                cd.splice(n, 1);
            }
        }
        else {
            if (!cd.includes(id)) {
                cd.push(id);
            }
        }
        this.setState({ categoriaCheck: cd });
        /*console.log(this.state.categoriaCheck);*/
        var details = JSON.stringify({ "Unidad": this.state.unidadCheck, "Categoria": this.state.categoriaCheck });
        /*console.log(details);*/
    };
    AddSuscripcion.prototype.end = function () {
        espolAds_1.expiro();
        this.props.history.push('/general/principal');
    };
    AddSuscripcion.prototype.render = function () {
        var contents = (this.state.status == 0)
            ? React.createElement("div", null,
                React.createElement("h5", { className: "title" }, "Loading...."),
                React.createElement("div", { className: "loader" }))
            : (this.state.status != 200 && this.state.status != 201) ? this.end()
                : this.renderCreateForm(this.state.categoriaList, this.state.unidadList);
        /*let edit = this.state.editando*/
        return React.createElement("div", null,
            React.createElement("div", { id: "top" }),
            React.createElement(reactstrap_1.Card, null,
                React.createElement(reactstrap_1.CardHeader, null,
                    React.createElement("h5", { className: "title" }, "PREFERENCIAS")),
                React.createElement(reactstrap_1.CardBody, null, contents)));
    };
    AddSuscripcion.prototype.refreshPage = function () {
        window.location.reload(false);
    };
    AddSuscripcion.prototype.handleSave = function (event) {
        var _this = this;
        //console.log("entre al handle");
        var unidades = this.state.unidadCheck;
        //for (var i = 0; i < unidades.length; i++) {
        //    forma.append('unidad', unidades[i]);
        //}
        var categorias = this.state.categoriaCheck;
        //for (var i = 0; i < categorias.length; i++) {
        //    forma.append('categoria', categorias[i]);
        //}        
        var data = JSON.stringify({ "Unidad": unidades, "Categoria": categorias });
        // PUT request for Edit employee.  
        if (1 == 1) {
            event.preventDefault();
            fetch(preferencias, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + espolAds_1.getCookie('token')
                },
                body: data,
            })
                .then(function (response) {
                response.json();
                _this.props.history.push("/add-suscripcion");
                window.location.reload();
            });
        }
    };
    // This will handle Cancel button click event.  
    AddSuscripcion.prototype.handleCancel = function (e) {
        e.preventDefault();
        this.props.history.push("/general/principal");
    };
    // Returns the HTML Form to the render() method.  
    AddSuscripcion.prototype.renderCreateForm = function (categoriaList, unidadList) {
        var _this = this;
        var nuni = unidadList.length % 4;
        var relluni = (4 - nuni) * 3;
        var coluni = "col-md-" + relluni;
        var ncate = categoriaList.length % 4;
        var rellcate = (4 - ncate) * 3;
        var colcate = "col-md-" + rellcate;
        return (React.createElement("form", { className: "col-md-11" },
            React.createElement("h3", { className: "title-blue" }, "SUSCRIBIRSE A: "),
            React.createElement("p", { className: "subtitle-blue" }, "Unidades"),
            React.createElement("div", { className: "col-md-12" }),
            React.createElement("br", null),
            React.createElement("div", { className: "form-group row" },
                React.createElement("div", { className: "col-md-12" },
                    React.createElement(reactstrap_1.Row, null,
                        unidadList.map(function (unidad) {
                            return React.createElement(React.Fragment, null,
                                React.createElement("div", { className: "col-md-1" },
                                    React.createElement("input", { className: "form-control", key: unidad.idUnidad, checked: _this.state.unidadCheck.includes(unidad.idUnidad.toString()), name: unidad.idUnidad, type: "checkbox", onClick: function () { return _this.handleCheck(unidad.idUnidad.toString(), _this.state.unidadCheck.includes(unidad.idUnidad.toString())); }, value: "true" })),
                                React.createElement("label", { className: " col-md-2 text-check-blue", htmlFor: "Name" },
                                    React.createElement("strong", { className: "valor" }, unidad.txNombreUnidad)));
                        }),
                        React.createElement("div", { className: coluni })))),
            React.createElement("br", null),
            React.createElement("p", { className: "subtitle-blue" }, "Categor\u00EDas"),
            React.createElement("div", { className: "col-md-12" }),
            React.createElement("br", null),
            React.createElement("div", { className: "form-group row" },
                React.createElement("div", { className: "col-md-12" },
                    React.createElement(reactstrap_1.Row, null,
                        categoriaList.map(function (categoria) {
                            return React.createElement(React.Fragment, null,
                                React.createElement("div", { className: "col-md-1" },
                                    React.createElement("input", { className: "form-control", key: categoria.idCategoria, checked: _this.state.categoriaCheck.includes(categoria.idCategoria.toString()), name: categoria.idCategoria, type: "checkbox", onClick: function () { return _this.handleCheckCat(categoria.idCategoria.toString(), _this.state.categoriaCheck.includes(categoria.idCategoria.toString())); }, value: "true" })),
                                React.createElement("label", { className: " control-label col-md-2 container text-check-blue", htmlFor: "Name" },
                                    React.createElement("strong", { className: "valor" }, categoria.txNombreCategoria)));
                        }),
                        React.createElement("div", { className: colcate })))),
            React.createElement("div", { className: "form-group row menu" },
                React.createElement("label", { className: " control-label col-md-8", htmlFor: "Name" }),
                React.createElement("div", { className: "col-md-4" },
                    React.createElement("button", { type: "submit", className: "btn-info btn-round", onClick: this.handleSave }, "Guardar"),
                    "\u00A0\u00A0\u00A0",
                    React.createElement("button", { className: "btn-warning btn-round", onClick: this.handleCancel }, "Cancelar")))));
    };
    return AddSuscripcion;
}(React.Component));
exports.AddSuscripcion = AddSuscripcion;
//# sourceMappingURL=AddSuscripcion.js.map